export enum UserTaskType {
  USER_TASKS_NEW = 'Nowe',
  USER_TASKS_ASSIGNED ='Zaplanowane',
  USER_TASKS_DELAYED = 'Opóźnione',
  USER_TASKS_CLOSED ='Zrealizowane'
}

export function valueOfUserTaskType(typeStr: string) {
  return UserTaskType[typeStr.toUpperCase() as keyof typeof UserTaskType];
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/interfaces/user-task-type.enum.ts